<form class="sdp-saml-wizard-form" [formGroup]="form" novalidate>
	<div class="sdp-clear"></div>
	<div>
		<div class="sdp-form-control">
			<div class="sdp-wizard-field-message">
				{{ "application.wizard.web.url.message" | translate }}
			</div>
			<mat-form-field class="sdp-form-control-input-container">
				<input autofocus=true matInput placeholder="{{ 'application.wizard.web.form.label.web' | translate }}"
					type="text" formControlName="webUrl">
				<mat-error
					*ngIf="form.controls['webUrl'].hasError('invalidWebUrl') || form.controls['webUrl'].hasError('required')">
					{{ "error.form.webUrl" | translate }}.</mat-error>
			</mat-form-field>
		</div>
	</div>
</form>